import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";
import GetRate from "@/components/requests/internal/GetRate.vue";
import ColorType from "@/components/functionals/ColorType.vue";

export const ColumnsRequests = [
  {
    prop: "Id",
    name: "NO",
    label: "NO",
    width: 80,
    sortable: true,
    formatter: SLAClolorStatus
  },
  {
    prop: "CustomerName",
    name: "Cliente",
    label: "Cliente",
    minWidth: 300
  },
  {
    prop: "ServiceRequestType.Description",
    name: "Solictud",
    label: "Solictud",
    sortable: true,
    minWidth: 200
  },
  {
    prop: "DeviceQuantity",
    name: "Cantidad",
    label: "Cantidad",
    align: "center",
    width: 110,
    sortable: true
  },
  {
    prop: "Device",
    name: "Equipo",
    label: "Equipo",
    width: 80
  },
  {
    prop: "AssignedTechnician.FullName",
    name: "Tecnico",
    label: "Tecnico",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "AssignedTechnicianImage"
    }
  },
  {
    prop: "Customer.CustomerService",
    name: "Servicio",
    label: "Servicio",
    formatter: ImagePerson,
    minWidth: 250,
    sortable: true,
    attrs: {
      imgKey: "CustomerServiceImage"
    }
  },
  {
    name: "Clasificación",
    label: "Clasificación",
    prop: "Customer.Clasification",
    width: 130,
    sortable: true
  },
  {
    prop: "SLAHoursToRespond",
    name: "SLA",
    label: "SLA",
    minWidth: 75,
    sortable: true
  },
  {
    //prop: "DiasRetraso",
    name: "Retraso",
    label: "Retraso",
    align: "center",
    minWidth: 100,
    sortable: true,
    formatter: ColorType
  },
  {
    prop: "RequestDate",
    name: "Creado",
    label: "Creado",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  },
  {
    prop: "DueDate",
    name: "Limite",
    label: "Limite",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  },
  {
    prop: "CreatedByUser.FirstName",
    name: "Creada Por",
    label: "Creada Por",
    formatter: ImagePerson,
    minWidth: 250,
    sortable: true,
    attrs: {
      imgKey: "CreatedByImage"
    }
  },
  {
    prop: "StatusDescription",
    name: "Estado",
    label: "Estado",
    minWidth: 100
  },
  {
    prop: "Valoracion",
    name: "Calificacion",
    label: "Calificacion",
    sortable: true,
    formatter: GetRate,
    minWidth: 145
  },
  {
    prop: "ValoracionComents",
    name: "Nota de Calificacion",
    label: "Nota de Calificacion",
    minWidth: 200
  },
  {
    prop: "ServiceRequestCloseDate",
    name: "Fecha Cierre",
    label: "Fecha Cierre",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  },
  {
    prop: "CommentOnLate",
    name: "Comentario de Servicio",
    label: "Comentario de Servicio",
    minWidth: 200
  }
];

export const ActionsRquests = [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-request-onLate"
  },
  {
    icon: "el-icon-s-comment",
    label: "Agregar comentario",
    command: "AddComment-onLate"
  }
];
